import * as React from "react";
import {cx} from "emotion";

import "./notification.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {chain}          from "@Common/utils/fs";

import {CloseBtn}    from "./close-svg";
import {ErrorIcon}   from "./error-icon-svg";
import {InfoIcon}    from "./info-icon-svg";
import {WarningIcon} from "./warning-icon-svg";

export const Notifications = () => cs(
    consumeContext("notifyMsgs"),
    ["closed", (_, next) => UseState({
        next,
    })],
    ({notifyMsgs, closed}) => (
        notifyMsgs?.["messages"]?.map((notification, key) => chain(
            notification.type === "information" ? {
                className: "information",
                label: "INFO",
                icon: InfoIcon(),
            } : notification.type === "warning" ? {
                className: "warning",
                label: "WARNING",
                icon: WarningIcon(),
            } : notification.type === "error" && {
                className: "error",
                label: "ERROR",
                icon: ErrorIcon(),
            },
            ({className, label, icon}) => (
                <div key={key} className={cx("notification-3ad", className)}>
                    <div className="icon">{icon}</div>
                    <div className="message" xd-qa-name="error message" xd-qa-type="label">
                        <b>{label}: </b>{notification.message}
                    </div>
                    <i className={"close-btn item"} onClick={()=>{closed.onChange(true); notifyMsgs["messages"].splice(key, 1);}}><CloseBtn/></i>
                </div>
            )
        ))
    )
);
